/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * Returns List of StoreBanner
 * Alfapeople -Customisation object -For Stor selection page
 */

import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';

export interface ISteps {
  stepDescription?: string;
  stepImage?: string;
}

/**
 *
 * StoreBanner component
 * @extends {React.PureComponent<IOurStoresProps<IOurStoresData>>}
 */
export class Steps extends Component {
  private readonly stepList: ISteps[] = [
    {
      stepDescription: 'LEGO bricks<br/>Your favorite photo!',
      stepImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1ZYt',
    },
    {
      stepDescription:
        'This LEGO picture frame is perfect for any 4x6 or 5x7 photo you want to display. The LEGO base for your photo frame is made of six 4x4 LEGO plates. Use 10 2x4 LEGO bricks in two rows of five bricks to create the base for your photo frame.',
      stepImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1ZYs',
    },
    {
      stepDescription:
        'Time to build up! Stack 4, 14-brick high columns using 2x4 LEGO bricks. Once built, your frame will look like it has two thick 4x4 columns with a slit between them.',
      stepImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1Urq',
    },
    {
      stepDescription:
        'Slide the photo between the slits in the LEGO brick columns.',
      stepImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1Xs8',
    },
    {
      stepDescription:
        'Build the top of the frame and enclose the picture. We used one 2x4 LEGO brick on each side to seal the columns, and six 2x8 LEGO bricks to cover the top of the picture, with two 2x4 LEGO bricks to secure the top of the frame.',
      stepImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1ZYu',
    },
  ];
  public render(): JSX.Element | null {
    return (
      <React.Fragment>
        <div className='row'>
          <h5 className='diy-small-heading-padding0'>What You’ll Need:</h5>

          {this.stepList.map((item) => (
            <React.Fragment>
              <div className='col-lg-12 col-md-12'>
                <div className='step-text'>
                  <p>{ReactHtmlParser(item.stepDescription)}</p>
                </div>
              </div>
              <div className='col-lg-12 col-md-12'>
                <div className='step-image'>
                  <img
                    className='img-responsive'
                    src={item.stepImage}
                    alt='bay doll sleeping bag'
                  />
                </div>
              </div>
            </React.Fragment>
          ))}
        </div>
      </React.Fragment>
    );
  }
}

export default Steps;
